import React, { FC } from 'react';
import { IFormItemType } from '@interfaces/FormItemType';
import { Col, Row } from 'react-bootstrap';
import { GeneratedForm } from '@ui/components/molecules/GeneratedForm';

type Props = {
  items: IFormItemType[];
  title?: string;
  withDivider?: boolean;
  isCenter?: boolean;
  isSmallLabel?: boolean;
};

export const SubFormSection: FC<Props> = ({ title, withDivider, items, isSmallLabel }) => {
  return (
    <Row className="w-100 mb-3">
      {withDivider && <hr style={{ borderColor: '#E9E9E9', borderWidth: 2 }} />}
      {title && (
        <Col sm={12}>
          <h5 className="text-center my-3">{title}</h5>
        </Col>
      )}
      <GeneratedForm items={items} isSmallLabel={isSmallLabel} />
    </Row>
  );
};
